import { isEmpty } from "@s-libs/micro-dash";

import { API_BASE_URL } from "@/api/api.config";
import fetchJson from "@/remoteState/fetchJson";
import isValidEmailPattern from "@/utils/isValidEmailPattern";

const validateRequired = (field) => !isEmpty(field);

const validateGreaterThan = (field, relatedField, inclusive = false) => {
  return inclusive ? +field >= +relatedField : +field > +relatedField;
};

const validateIfEmailIsUnique = async (email = null) => {
  if (!email) {
    return false;
  }

  try {
    const userInformation = await fetchJson(
      `${API_BASE_URL}/api/v2/user/?username=${encodeURIComponent(email)}`,
    );

    if (!isEmpty(userInformation)) {
      return false;
    }
  } catch (_error) {
    return true;
  }
};

const validateEmail = async (
  field,
  isRequired,
  originalEmail = null,
  skipUniqueValidation = false,
) => {
  if (isRequired && !validateRequired(field)) {
    return {
      isValid: false,
      message: "Enter an email",
    };
  }

  if (!isValidEmailPattern(field)) {
    return {
      isValid: false,
      message: "Enter a valid email",
    };
  }

  if (!!originalEmail && originalEmail === field) {
    return {
      isValid: false,
      message: "The new email is the same as the original email",
    };
  }

  if (skipUniqueValidation) {
    return { isValid: true, message: null };
  }

  const isEmailUnique = await validateIfEmailIsUnique(field);

  if (!isEmailUnique) {
    return {
      isValid: false,
      message: "This email address is already taken.",
    };
  }

  return { isValid: true, message: null };
};

const validateUsername = (field) => {
  if (!validateRequired(field)) {
    return {
      isValid: false,
      message: "Enter a username",
    };
  }

  return {
    isValid: true,
    message: null,
  };
};

const applyValidationResult = (
  isValid,
  errors,
  fieldName,
  errorMessage,
  errorCb,
) => {
  const errorExists = errors[fieldName];
  if (isValid && errorExists) {
    const { [fieldName]: n, ...other } = errors;
    errorCb(other);
  } else if (!isValid && (!errorExists || errors[fieldName] !== errorMessage)) {
    errorCb({
      ...errors,
      [fieldName]: errorMessage,
    });
  }
};

export default {
  validateEmail,
  validateIfEmailIsUnique,
  validateUsername,
  validateRequired,
  applyValidationResult,
  validateGreaterThan,
};
